"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.normalizeMerchRecommendations = exports.callPromptRecommendationApis = void 0;
var _domainServices = require("@site/domain-services");
const normalizeMerchRecommendations = (args = {}) => {
  if (!args || args === null) {
    // eslint-disable-line eqeqeq
    return args;
  }
  const {
    data = {}
  } = args;
  let recommendations = [];
  if (data?.RecommendedDomains?.length && data?.Products?.length) {
    recommendations = data.RecommendedDomains.map(recommendation => {
      // This value is expected to be on the domain object
      recommendation.IcannFeePrice = data.IcannFeePrice;
      return {
        recommendation: {
          domainName: recommendation.Fqdn,
          extension: recommendation.Extension,
          nameWithoutExtension: recommendation.NameWithoutExtension,
          matchSource: recommendation.MatchSource,
          domainObject: recommendation,
          isRestricted: recommendation.IsRestricted
        },
        product: data.Products.find(product => product.ProductId === recommendation.ProductId)
      };
    }).filter(({
      product
    }) => Boolean(product));
  }
  return {
    ...data,
    recommendations
  };
};
exports.normalizeMerchRecommendations = normalizeMerchRecommendations;
const callPromptRecommendationApis = async (params, urlOverride, apm) => {
  try {
    const merchRecommendationPromise = (0, _domainServices.getMerchRecommendPromise)(params, urlOverride, apm);
    const wamVenturePromise = (0, _domainServices.getWamVenturePromise)(params, urlOverride, apm);
    const results = await Promise.allSettled([merchRecommendationPromise, wamVenturePromise]);
    const merchData = results[0].status === 'fulfilled' ? results[0].value : null;
    const ventureData = results[1].status === 'fulfilled' ? results[1].value : null;
    return {
      merchData: normalizeMerchRecommendations(merchData),
      ventureData
    };
  } catch (error) {
    console.error('callVentureMerchApis:error', error); // eslint-disable-line no-console
  }
};
exports.callPromptRecommendationApis = callPromptRecommendationApis;